document.addEventListener('DOMContentLoaded', function () {
  const productSections = document.querySelectorAll(
    '[data-voloom-product]'
  );

  productSections.forEach(function (section) {
    let productDataEl = section.querySelector(
      '[data-voloom-product-json]'
    );

    if (!productDataEl) {
      productDataEl = document.querySelector(
        '[data-voloom-product-json]'
      );
    }

    if (!productDataEl) {
      console.warn('Voloom: Product JSON not found', section);
      return;
    }

    let product;

    try {
      product = JSON.parse(productDataEl.textContent);
    } catch (error) {
      console.error('Voloom: Failed to parse product JSON', error);
      return;
    }

    const mainMedia = section.querySelector(
      '[data-voloom-main-media]'
    );
    const thumbsWrap = section.querySelector('.voloom-thumbs');
    const variantInput = section.querySelector('input[name="id"]');
    const priceEl = section.querySelector('[data-voloom-price]');
    const compareEl = section.querySelector(
      '[data-voloom-compare]'
    );
    const saveEl = section.querySelector('[data-voloom-save]');
    const stickyPrice = section.querySelector(
      '[data-voloom-sticky-price]'
    );
    const stickyName = section.querySelector(
      '[data-voloom-sticky-name]'
    );
    const submit = section.querySelector('[data-voloom-submit]');
    const optionInputs = section.querySelectorAll(
      '[data-voloom-option-input]'
    );

    function money(cents) {
      if (
        window.Shopify &&
        typeof window.Shopify.formatMoney === 'function'
      ) {
        return window.Shopify.formatMoney(cents);
      }

      const currency =
        window.Shopify?.currency?.active ||
        window.Shopify?.currency?.default ||
        'QAR';

      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency
      }).format((cents || 0) / 100);
    }

    function updateMedia(mediaId) {
      if (!mainMedia || !mediaId) return;

      const btn = section.querySelector(
        '[data-media-id="' + mediaId + '"]'
      );

      if (!btn) return;

      const src = btn.dataset.image;
      if (!src) return;

      const thumbnailImage = btn.querySelector('img');
      const image = document.createElement('img');

      image.src = src;
      image.alt = thumbnailImage?.alt || product.title || '';
      image.width = 1200;
      image.loading = 'eager';
      image.style.width = '100%';
      image.style.height = 'auto';
      image.style.display = 'block';

      mainMedia.innerHTML = '';
      mainMedia.appendChild(image);

      section
        .querySelectorAll('[data-voloom-thumb]')
        .forEach(function (thumb) {
          thumb.classList.remove('is-active');
        });

      btn.classList.add('is-active');
    }

    if (thumbsWrap) {
      thumbsWrap.addEventListener('click', function (event) {
        const btn = event.target.closest('[data-voloom-thumb]');

        if (!btn || !thumbsWrap.contains(btn)) return;

        event.preventDefault();

        const mediaId = btn.dataset.mediaId;

        if (mediaId) {
          updateMedia(mediaId);
        }
      });
    }

    function setVariant(variant) {
      if (!variant) return;

      if (variantInput) {
        variantInput.value = variant.id;
      }

      if (priceEl) {
        priceEl.textContent = money(variant.price);
      }

      if (stickyPrice) {
        stickyPrice.textContent = money(variant.price);
      }

      if (stickyName) {
        stickyName.textContent = product.title;
      }

      const hasDiscount =
        variant.compare_at_price &&
        variant.compare_at_price > variant.price;

      if (compareEl) {
        if (hasDiscount) {
          compareEl.textContent = money(
            variant.compare_at_price
          );
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      if (saveEl) {
        if (hasDiscount) {
          const percentage = Math.round(
            (
              (variant.compare_at_price - variant.price) /
              variant.compare_at_price
            ) * 100
          );

          saveEl.textContent = 'SAVE ' + percentage + '%';
          saveEl.style.display = '';
        } else {
          saveEl.style.display = 'none';
        }
      }

      if (submit) {
        submit.disabled = !variant.available;
      }

      if (variant.featured_media?.id) {
        updateMedia(variant.featured_media.id);
      } else if (variant.featured_image?.id) {
        updateMedia(variant.featured_image.id);
      }

      optionInputs.forEach(function (input) {
        const optionIndex = Number(input.dataset.optionIndex);

        input.checked =
          variant.options?.[optionIndex] === input.value;
      });
    }

    function findVariantFromOptions() {
      const selectedOptions = [];

      optionInputs.forEach(function (input) {
        if (input.checked) {
          selectedOptions[Number(input.dataset.optionIndex)] =
            input.value;
        }
      });

      return product.variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return (
            !selectedOptions[index] ||
            option === selectedOptions[index]
          );
        });
      });
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        const variant = findVariantFromOptions();

        if (variant) {
          setVariant(variant);
        }
      });
    });

    const initialVariant = product.variants.find(function (variant) {
      return (
        variantInput &&
        String(variant.id) === String(variantInput.value)
      );
    });

    if (initialVariant) {
      setVariant(initialVariant);
    }
  });
});